import React, { useEffect, useState } from "react";
import RoutinesView from "../components/RoutinesView";
import AppShell from "../components/AppShell";
import api from "../lib/api";

export default function Calisthenics() {
  const [profile, setProfile] = useState(null);
  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data)).catch(() => {});
  }, []);
  if (!profile) {
    return <AppShell title="Calistenia"><div className="text-[var(--mep-text-muted)]">Cargando...</div></AppShell>;
  }
  return (
    <RoutinesView
      sex={profile.sex}
      title="Calistenia"
      subtitle="Entrena con tu propio peso corporal."
      muscleFilter="calistenia"
      hideWeeklyPlan
    />
  );
}
